<template>
  <OrqTheme>
    <OrqLayout full>
      <MainNavbar />

      <div class="app-main-container__fullpage">
        <RouterView />
      </div>

      <slot name="footer">
        <MainFooter />
      </slot>
     
    </OrqLayout>
  </OrqTheme>
</template>

<script setup>
import { RouterView } from 'vue-router';
import { OrqTheme, OrqLayout } from '@digital/orquestra';
import MainNavbar from './components/main/MainNavbar.vue';
import MainFooter from './components/main/MainFooter.vue';
</script>

<style lang="scss" scoped>
.app-main-container {
  padding: 2rem 1.25rem 70px;
  min-height: calc(100vh );
  
  max-width: 1280px;
  margin: 0 auto;

  &__banner-header {
    padding-top: 1rem;
  }

  &__fullpage {
    padding-top: 0;
    padding-left: 0;
    padding-right: 0;
    min-width: calc(100% + 40px);
    transform: translateX(-20px);

    /* Móvil: sin desplazamiento, evita overflow horizontal */
    @media screen and (max-width: 1023px) {
      min-width: 100%;
      transform: none;
    }
  }


}
</style>
